<template>
  <header class="lk-header">
    <div class="lk-header__topbar t-lk-container">
      <div class="lk-header-topbar">
        <p class="lk-header-topbar__info">
          Проконсультируем по вопросам работы с Axoft Online
          <a href="tel:88007002855" class="lk-header-topbar__phone">8 800 700-28-55</a>
        </p>
        <ul class="lk-header-topbar__link-list">
          <li class="lk-header-topbar__link-item">
            <a class="lk-header-topbar__link" href="https://axoftglobal.ru" target="_blank">
              <GlobeSvg />
              Перейти на AxoftGlobal
            </a>
          </li>
          <li class="lk-header-topbar__link-item">
            <a class="lk-header-topbar__link"  href="https://online.axoftglobal.ru/help-content">
              <QuestionSvg />
              Справка
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="lk-header__bottom lk-header-bottom t-lk-container">
      <BurgerBtn class="lk-header-bottom__burger-btn" v-model="visibleMobileMenu" />

      <lk-tablet-menu v-model="visibleMobileMenu" :menu="menu" />

      <a class="lk-header-bottom__logo" href="https://online.axoftglobal.ru/order/list?pages=1">
        <AxoftOnlineSvg />
      </a>

      <nav class="lk-header-bottom__menu">
        <ul class="lk-header-bottom__menu-list">
          <li
            v-for="(menuItem, idx) in menu"
            :key="menuItem.name"
            :class="[
              'lk-header-bottom__menu-item',
              { 'lk-header-bottom__menu-item--has-dropdown': hasSubMenu(menuItem) },
              { 'lk-header-bottom__menu-item--active': isActiveMenuItem(menuItem) },
            ]"
            @mouseenter="setActiveMenuIdx(idx)"
            @mouseleave="unsetActiveMenuIdx"
          >
            <template v-if="hasSubMenu(menuItem)">
              <div class="lk-header-bottom__menu-btn-wrapper">
                <button class="lk-header-bottom__menu-btn" :aria-label="menuItem.name">
                  {{ menuItem.name }}
                  <TriangleFilled class="lk-header-bottom__menu-icon-direction" />
                </button>
              </div>
              <transition name="submenu">
                <div v-if="activeMenuIdx === idx" class="lk-header-bottom__sub-menu-wrapper">
                  <ul v-if="menuItem.submenu" class="lk-header-bottom__sub-menu" role="menu">
                    <li
                      v-for="submenu in menuItem.submenu"
                      :key="submenu.name"
                      :class="[
                        'lk-header-bottom__sub-menu-item',
                        { 'lk-header-bottom__sub-menu-item--active': isActivePage(submenu.link, submenu.name) },
                      ]"
                      @click="unsetActiveMenuIdx"
                    >
                      <t-link class="lk-header-bottom__sub-menu-link" :link="submenu.link">
                        {{ submenu.name }}
                      </t-link>
                    </li>
                  </ul>
                </div>
              </transition>
            </template>
            <template v-else>
              <t-link class="lk-header-bottom__menu-link" :link="menuItem.link">{{ menuItem.name }}</t-link>
            </template>
          </li>
        </ul>

        <div class="lk-header-bottom__actions">
          <Notifications class="lk-header-bottom__notifications" />
          <div
            class="lk-header-bottom__user lk-header-bottom__menu-item--has-dropdown"
            @mouseenter="isActiveUserMenuIdx = true"
            @mouseleave="isActiveUserMenuIdx = false"
          >
            <button class="lk-header-bottom__actions-btn" :title="`${profile.name} ${profile.surname}`">
              <UserSvg />
            </button>
            <transition name="submenu">
              <div v-if="isActiveUserMenuIdx" class="lk-header-bottom__sub-menu-wrapper user-sub-menu-wrapper">
                <ul class="lk-header-bottom__sub-menu" role="menu">
                  <li class="lk-header-bottom__sub-menu-item">
                    <router-link class="lk-header-bottom__sub-menu-link" :to="{ name: 'lk-security' }">
                      {{ $root.staticText.lk.settings }}
                    </router-link>
                  </li>
                  <li class="lk-header-bottom__sub-menu-item">
                    <a class="lk-header-bottom__sub-menu-link" :href="linkLogout">
                      {{ $root.staticText.lk.logout }}
                    </a>
                  </li>
                </ul>
              </div>
            </transition>
          </div>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
import "./style.sass"
import { mapGetters, mapMutations } from "vuex"
import AxoftOnlineSvg from "@assets/lk/img/AxoftOnline.svg?inline"
import BellSvg from "@assets/lk/img/Bell.svg?inline"
import GlobeSvg from "@assets/lk/img/Globe.svg?inline"
import UserSvg from "@assets/lk/img/User.svg?inline"
import QuestionSvg from "@assets/lk/img/Question.svg?inline"
import TriangleFilled from "@assets/lk/img/TriangleFilled.svg?inline"
import Notifications from "@components/lk/lk-header/notifications"
import BurgerBtn from "@components/ui-components/burger-btn"
import lkTabletMenu from "@components/lk/lk-tablet-menu/lk-tablet-menu"
import tLink from "@components/ui-components/t-link"

export default {
  name: "lk-header",
  components: {
    AxoftOnlineSvg,
    BellSvg,
    GlobeSvg,
    UserSvg,
    QuestionSvg,
    TriangleFilled,
    Notifications,
    BurgerBtn,
    lkTabletMenu,
    tLink,
  },
  data() {
    return {
      activeMenuIdx: null,
      isActiveUserMenuIdx: false,
      visibleMobileMenu: false,
    }
  },
  computed: {
    ...mapGetters("lk", ["profile", "linkLogout"]),
    menu() {
      return this.$root?.lk?.menu ?? []
    },
  },
  methods: {
    ...mapMutations("mobile", ["toggleMobileMenu"]),
    toggleDropdown(menu) {
      this.dropdowns[menu] = !this.dropdowns[menu]
    },
    // (item: object): bool
    hasSubMenu(item) {
      return !!item?.submenu
    },
    // (idx: number):
    setActiveMenuIdx(idx) {
      this.activeMenuIdx = idx
    },
    unsetActiveMenuIdx() {
      this.activeMenuIdx = null
    },
    isActiveMenuItem(menuItem) {
      if (this.hasSubMenu(menuItem)) return menuItem.submenu.some($ => this.isActivePage($?.link))
      else return this.isActivePage(menuItem?.link)
    },
    isActivePage(pageName, name) {
      return pageName && this.$route.name === pageName
    },
  },
  watch: {
    $route: function() {
      this.visibleMobileMenu = false
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/templates/components/lk/lk-header/index.vue